<template>
  <div class="leviy-web min-h-screen flex flex-col">
    <NavBar />

    <main class="flex-grow">
      <router-view />
    </main>

    <SideFloatingBar />
    <Footer />
  </div>
</template>

<script setup>
import NavBar from './components/NavBar.vue'
import SideFloatingBar from './components/SideFloatingBar.vue'
import Footer from './components/Footer.vue'
</script>
